const state = () => ({
  locale: 'it' // default di avvio
})

const mutations = {
  setLocale(state, lang) {
    state.locale = lang
  }
}

export const lang = {
  namespaced: true,
  state,
  mutations
}